import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diaglab-bill-item.reducer';

export const DiaglabBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diaglabBillItemEntity = useAppSelector(state => state.diaglabBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diaglabBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diaglabBillItem.detail.title">DiaglabBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.id}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.price">Price</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.price}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.timestampentry}</dd>
          <dt>
            <span id="statusCode">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.statusCode">Status Code</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.statusCode}</dd>
          <dt>
            <span id="cancelledReason">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.cancelledReason">Cancelled Reason</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.cancelledReason}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.discount}</dd>
          <dt>
            <span id="paidAmount">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.paidAmount">Paid Amount</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.paidAmount}</dd>
          <dt>
            <span id="groupPanelId">
              <Translate contentKey="tinyMedicRestApp.diaglabBillItem.groupPanelId">Group Panel Id</Translate>
            </span>
          </dt>
          <dd>{diaglabBillItemEntity.groupPanelId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillItem.panel">Panel</Translate>
          </dt>
          <dd>{diaglabBillItemEntity.panel ? diaglabBillItemEntity.panel.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillItem.diaglabBill">Diaglab Bill</Translate>
          </dt>
          <dd>{diaglabBillItemEntity.diaglabBill ? diaglabBillItemEntity.diaglabBill.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillItem.diaglabPricing">Diaglab Pricing</Translate>
          </dt>
          <dd>{diaglabBillItemEntity.diaglabPricing ? diaglabBillItemEntity.diaglabPricing.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillItem.labTestItem">Lab Test Item</Translate>
          </dt>
          <dd>{diaglabBillItemEntity.labTestItem ? diaglabBillItemEntity.labTestItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillItem.scheme">Scheme</Translate>
          </dt>
          <dd>{diaglabBillItemEntity.scheme ? diaglabBillItemEntity.scheme.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diaglabBillItem.accessEntry">Access Entry</Translate>
          </dt>
          <dd>{diaglabBillItemEntity.accessEntry ? diaglabBillItemEntity.accessEntry.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diaglab-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diaglab-bill-item/${diaglabBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiaglabBillItemDetail;
